import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { ProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/product-category-entity';
import { ProductCategoryRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/product-category-request';
import { ProductCategoryType } from 'src/app/assabil-kernel/models/entities/control-tables/product-category-type-entity';


@Component({
    selector: 'product-category-widget',
    templateUrl: './product-category-widget.component.html',
    styleUrls: ['./product-category-widget.component.scss']
})

export class ProductCategoryWidgetComponent extends BaseWidget {
  
  productCategory            : ProductCategory = new ProductCategory();

 
  constructor(
      protected promoService         : PromoService,
      protected toastr               : ToastrService,
      protected controlTablesService : ControlTablesService,
      protected leanUtilsService     : LeanUtilsService) {
      super(toastr, leanUtilsService);

      this.entityName = "productCategory";
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
setEntity(productCategory: ProductCategory) {
  this.productCategory  = { ...productCategory };
  this.productCategory.productCategoryTypes = [];
  if (productCategory.productCategoryTypes) {
    for (let productCategoryType of productCategory.productCategoryTypes) {
      this.productCategory.productCategoryTypes.push({ ...productCategoryType });
    }
  }
}
//---------------------------------------------------------------------------------------

  
//---------------------------------------------------------------------------------------
  getEntity(){
    return this.productCategory;
  }
//---------------------------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(): Promise<ProductCategory> {
  let request: ProductCategoryRequest = new ProductCategoryRequest(this.controlTablesService.getUserInfo());
  request.productCategory = this.productCategory;
  return this.controlTablesService.save(this.entityName, request);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
  let productCategoryType : ProductCategoryType = new ProductCategoryType();
  productCategoryType.inserted = true;
  this.productCategory.productCategoryTypes.push(productCategoryType);
  this.productCategory.productCategoryTypes = [...this.productCategory.productCategoryTypes];
}
//----------------------------------------------------------------------


}
